export { default as NewCredDesign } from "./DesignContainer";
